import { FreteCaminhoneiroStatusCarregamentoEnum as StatusCarregamento } from "./FreteCaminhoneiroStatusCarregamentoEnum";
import { FreteCaminhoneiroSubstatusEnum as SubstatusCarregamento } from "./FreteCaminhoneiroSubstatusEnum";

export function normalizeStatusKey(status) {
  if (!status) return "";

  return status
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

const STATUS_SEVERITY = {
  pendente: "warning",
  aceito: "info",
  andamento: "info",
  finalizado: "success",
  cancelado: "danger",
  em_andamento: "info",
  em_analise: "neutral",
  finalizada: "success",
  aguardando: "warning",
  aguardando_resposta: "warning",
  em_transito: "info",
  cancelada: "danger",
  suspensa: "warning",
  suspensa_op: "warning",
  recusada: "danger",
  liberado: "success",

  [normalizeStatusKey(StatusCarregamento.AGENDADO)]: "neutral",
  [normalizeStatusKey(StatusCarregamento.AGUARDANDO_AVALIACAO)]: "neutral",
  [normalizeStatusKey(StatusCarregamento.A_CAMINHO_PATIO)]: "info",
  [normalizeStatusKey(StatusCarregamento.NO_PATIO)]: "warning",
  [normalizeStatusKey(StatusCarregamento.CHAMADO)]: "info",
  [normalizeStatusKey(StatusCarregamento.A_CAMINHO_ARMAZEM)]: "info",
  [normalizeStatusKey(StatusCarregamento.NO_ARMAZEM)]: "info",
  [normalizeStatusKey(StatusCarregamento.EM_CARREGAMENTO)]: "info",
  [normalizeStatusKey(StatusCarregamento.EM_VIAGEM)]: "info",
  [normalizeStatusKey(StatusCarregamento.EM_DESCARREGAMENTO)]: "info",
  [normalizeStatusKey(StatusCarregamento.VIAGEM_FINALIZADA)]: "success",
  [normalizeStatusKey(StatusCarregamento.FINALIZADO)]: "success",
  [normalizeStatusKey(StatusCarregamento.FINALIZADO_APP)]: "success",
  [normalizeStatusKey(StatusCarregamento.CANCELADO)]: "danger",
  [normalizeStatusKey(StatusCarregamento.RECUSADO_MOTORISA)]: "danger",

  [normalizeStatusKey(SubstatusCarregamento.NAO_APTO)]: "danger",
  [normalizeStatusKey(SubstatusCarregamento.APTO)]: "success",
  [normalizeStatusKey(SubstatusCarregamento.CHAMADO)]: "info",
  [normalizeStatusKey(SubstatusCarregamento.TRIADO)]: "success",
};

export function getStatusSeverity(status, fallback = "neutral") {
  return STATUS_SEVERITY[normalizeStatusKey(status)] || fallback;
}
